import { createSlice } from '@reduxjs/toolkit'
import add from './reducers/addBox'
import remove from './reducers/removeBox'
import setAlias from './reducers/setBoxAlias'
import _editBoxLabels from './reducers/editBoxLabels'
import setUnopened from './reducers/setUnopenedCount'

export const slice = createSlice({
  name: 'boxes',
  initialState: {
    boxes: {},
    boxesCount: 0,
  },
  reducers: {
    addBox: add,
    addBoxes: (state, action) => {
      const boxes = action.payload
      boxes.forEach((box) => {
        add(state, { payload: box })
      })
    },
    removeBox: remove,
    setBoxAlias: setAlias,
    editBoxLabels: _editBoxLabels,
    setUnopenedCount: setUnopened,
    toggleArchivedBox: (state, action) => {
      const { boxId } = action.payload
      const box = Object.values(state.boxes).find((box) => box.composedid === boxId)
      state.boxes[box.id].archived = !state.boxes[box.id].archived
    },
    setSelectedBoxesForEditing: (state, action) => {
      const selectedBoxes = action.payload
      state.selectedBoxes = selectedBoxes
    }
  },
})

export const { addBox, removeBox, addBoxes, setBoxAlias, editBoxLabels, setUnopenedCount, toggleArchivedBox, setSelectedBoxesForEditing } = slice.actions
export const selectCount = state => state.counter.value
export default slice.reducer
